import React from 'react';
import { Link } from 'react-router-dom';
import { FaWarehouse, FaCogs, FaHandshake, FaShieldAlt, FaLeaf, FaArrowRight } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/hero/hero-banner.png';
import './Home.css';

const services = [
  {
    icon: <FaWarehouse />,
    title: 'Warehousing & Distribution',
    desc: 'Complete warehousing solutions for mechanical and electrical parts with efficient distribution networks.',
  },
  {
    icon: <FaCogs />,
    title: 'One Stop Shop',
    desc: 'We provide a comprehensive range of industrial fasteners, from standard products to precision custom parts.',
  },
  {
    icon: <FaHandshake />,
    title: 'Customer Excellence',
    desc: 'Focused on building lasting relationships through superior service and reliable product quality.',
  },
];

const Home = () => {
  return (
    <div className="home">
      <Hero
        eyebrow="Since 1941 · 東京鋲螺"
        title={<>Fastening Your <span className="highlight">Innovations</span></>}
        subtitle="Tokyo Byokane Philippines Corporation — your trusted partner for warehousing and distribution of mechanical and electrical parts since 2000."
        backgroundImage={heroBg}
        showCta
        ctaText="Explore Products"
        ctaLink="/products"
      />

      {/* Services Section */}
      <section className="home__services section">
        <div className="container">
          <p className="section-subtitle">What We Do</p>
          <h2 className="section-title">Our <span className="highlight">Services</span></h2>
          <div className="home__services-grid">
            {services.map((service, idx) => (
              <div className="service-card" key={idx}>
                <div className="service-card__icon">{service.icon}</div>
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__desc">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="home__mission section">
        <div className="container">
          <div className="home__mission-content">
            <div className="home__mission-text">
              <p className="section-subtitle">Our Mission</p>
              <h2 className="section-title">Customer Service with <span className="highlight">Excellence</span></h2>
              <p className="home__mission-desc">
                We focus on providing customer service with excellence. Our commitment to quality
                ensures that every product and interaction meets the highest standards of the industry.
              </p>
              <p className="home__mission-desc">
                With decades of experience and a global network of branches, we deliver reliable
                fastening solutions to industries worldwide.
              </p>
              <Link to="/about" className="btn btn-outline">
                Learn More <FaArrowRight />
              </Link>
            </div>
            <div className="home__mission-stats">
              <div className="stat-card">
                <span className="stat-card__number">80+</span>
                <span className="stat-card__label">Years of Heritage</span>
              </div>
              <div className="stat-card">
                <span className="stat-card__number">20+</span>
                <span className="stat-card__label">Global Locations</span>
              </div>
              <div className="stat-card">
                <span className="stat-card__number">14</span>
                <span className="stat-card__label">Countries</span>
              </div>
              <div className="stat-card">
                <span className="stat-card__number">10+</span>
                <span className="stat-card__label">Product Lines</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Policy Section */}
      <section className="home__quality section">
        <div className="container">
          <div className="home__quality-grid">
            <div className="quality-card">
              <div className="quality-card__icon"><FaShieldAlt /></div>
              <h3>Quality Policy</h3>
              <p>
                We are committed to providing cost-effective products and services that
                meet our customers' requirements and expectations. Continuous improvement
                of our quality management system ensures consistent delivery of excellence.
              </p>
            </div>
            <div className="quality-card">
              <div className="quality-card__icon"><FaLeaf /></div>
              <h3>Environmental Policy</h3>
              <p>
                We are dedicated to environmental responsibility and regulatory compliance.
                Our processes are designed to minimize environmental impact while maintaining
                the highest standards of product quality and safety.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
